import { createComponent } from '@lit/react';
import React from 'react';
import { SDSCheckbox } from '../sds-checkbox/sds-checkbox';
import { SheriffEventName } from './types';

export const SDSCheckboxWrapper = createComponent({
	tagName: 'sds-checkbox',
	elementClass: SDSCheckbox,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
	},
});
